import { useUserAuth } from '../../../state/userAuthContext';
import { NudosGenericModal } from '../../NudosComponents';
import './LogoutModal.scss';

const Logout = ({ closeModalCallback }: { closeModalCallback: () => void }) => {
  const { logOut } = useUserAuth();

  const handleClickLogout = () => {
    logOut && logOut();
    closeModalCallback();
  };

  if (!logOut) return <></>;

  return (
    <div className="logoutModal">
      <NudosGenericModal
        modalContent={<LogoutModal onClickLogout={handleClickLogout} closeLogoutModal={closeModalCallback} />}
        closesOnClickOutside={true}
        clickOutsideCallback={closeModalCallback}
        closeModalCallback={closeModalCallback}
      />
    </div>
  );
};

const LogoutModal = ({
  onClickLogout,
  closeLogoutModal
}: {
  onClickLogout: () => void;
  closeLogoutModal: () => void;
}) => {
  return (
    <div className="logoutModalContent">
      <div className="question">¿Seguro quieres cerrar sesión?</div>
      <div className="answers">
        <button onClick={onClickLogout}>Si</button>
        <button onClick={closeLogoutModal}>No</button>
      </div>
    </div>
  );
};

export default Logout;
